import { ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import {
  MRT_EditActionButtons as MRTEditActionButtons,
  MRT_Row,
  MRT_TableInstance
} from "material-react-table";
import { CateringServiceRow } from "./Domain/Types/FacilityService-row.types";
import { FileObject } from "../../../features/FileDropzone/typings/FileObject.type";
import { EditTableItemImageComp } from "../../Common/ListTablePartial/ListTablePartial.partial";
import { TransitionForSlideoutPanel } from "../../SlideoutPanel/SlideoutPanelTransition.component";

/** display simple cell */
export const renderSimpleCateringCellName = (name?: string) => (
  <Typography>{name ?? ""}</Typography>
);

/** display price per unit cell */
export const renderCateringPricePerUnitCell = (pricePerUnit: number) => (
  <Typography>{pricePerUnit.toFixed(2)}</Typography>
);

export const editCateringImage = ({
  title,
  header,
  rowOriginal,
  imageFile,
  setImageFile,
  setDeleteRowImage
}: {
  title: string;
  header: string;
  rowOriginal: CateringServiceRow;
  imageFile: { file: FileObject[] };
  setImageFile: (newImageFile: { file: FileObject[] }) => void;
  setDeleteRowImage: (item: { rowId: number | null; picturePath: string | null }) => void;
}) => {
  return (
    <EditTableItemImageComp
      title={title}
      header={header}
      rowOriginal={rowOriginal}
      imageFile={imageFile}
      setImageFile={setImageFile}
      setDeleteRowImage={setDeleteRowImage}
    />
  );
};

export function SlidePanelCreateEditService({
  table,
  row,
  internalEditComponents,
  headline
}: Readonly<{
  table: MRT_TableInstance<CateringServiceRow>;
  row: MRT_Row<CateringServiceRow>;
  internalEditComponents: ReactNode[];
  headline: string;
}>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const createOrEditDialogStyle = {
    height: "calc(-64px + 100vh)",
    maxHeight: "calc(-64px + 100vh)",
    maxWidth: isMobile ? "inherit" : "50vw",
    position: "absolute",
    right: 0,
    margin: 0,
    width: isMobile ? "100%" : "40vw",
    padding: 3,
    top: "64px"
  };

  return (
    <Dialog
      open
      data-testid="catering_edit_row_dialog"
      slotProps={{ paper: { sx: { ...createOrEditDialogStyle } } }}
      transitionDuration={400}
      slots={{ transition: TransitionForSlideoutPanel }}
    >
      {/* edit catering dialog contents */}
      <DialogTitle variant="h4">{headline}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", mt: 2 }}>
        <Grid2 container data-testid="edit-catering-dialog-contents" columnGap={4}>
          <Grid2 container size={{ xs: 12 }} rowGap={3.5}>
            {/* image */}
            {internalEditComponents[0]}
            {/* name */}
            {internalEditComponents[1]}
            {/* description */}
            {internalEditComponents[2]}
            {/* price per unit */}
            {internalEditComponents[3]}
            {/** location */}
            {internalEditComponents[4]}
            {/* permission */}
            {internalEditComponents[5]}
          </Grid2>
        </Grid2>
      </DialogContent>

      <Divider sx={{ mt: 3, mb: 3, opacity: "0.6" }} />
      <DialogActions>
        <MRTEditActionButtons variant="text" table={table} row={row} />
      </DialogActions>
    </Dialog>
  );
}
